import { defineComponent as _defineComponent } from 'vue'
import { reactive, ref, watch } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import CModal from '@/components/CModal.vue';
import LoaderBtn from '@/components/LoaderBtn/LoaderBtn.vue';
import { saveRateLimit } from '@/api/user';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApiRateLimitModal',
  props: {
    value: { type: Boolean, required: true as const },
    provider: { type: String, required: true as const },
    providerLabel: { type: String, required: true as const },
    attemptsPerIp: { default: null as number | null },
    retryAfterMinutes: { default: null as number | null }
},
  emits: ["input", "saved"],
  setup(__props, { emit }: { emit: ({
    (event: 'input', value: boolean): void;
    (event: 'saved'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const saving = ref(false);

const form = reactive({
    attemptsPerIp: null as number | null,
    retryAfterMinutes: null as number | null
});

watch(
    () => props.value,
    (open) => {
        if (open) {
            form.attemptsPerIp = props.attemptsPerIp;
            form.retryAfterMinutes = props.retryAfterMinutes;
        }
    }
);

const onSave = async () => {
    saving.value = true;
    try {
        await saveRateLimit({
            provider: props.provider,
            attemptsPerIp: form.attemptsPerIp || null,
            retryAfterMinutes: form.retryAfterMinutes || null
        });
        emit('saved');
        emit('input', false);
    } finally {
        saving.value = false;
    }
};

return { __sfc: true,emit, props, saving, form, onSave, FontAwesomeIcon, CModal, LoaderBtn }
}

})